import { Invoice, Bill } from '../invoicing/invoicing';
import { Job } from '../job/job';
import { WorkOrder } from '../job/workorder';

export enum WebHookEventName {
    JobCreated = 'Job Created',
    JobStatusChange = 'Job Status Change',
    JobFirstDispatch = 'Job First Dispatch',
    JobInvoiced = 'Job Invoiced',
    WorkOrderStatusChange = 'Work Order Status Change',
    WorkOrderBilled = 'Work Order Billed',
    ClaimStatusChange = 'Claim Status Change',
    InvoiceCreated = 'Invoice Created',
    InvoiceStatusChange = 'Invoice Status Change',
    InvoiceFullyPaid = 'Invoice Fully Paid',
    BillFullyPaid = 'Bill Fully Paid',
    BillCreated = 'Bill Created',
    BillStatusChange = 'Bill Status Change',
    InvoiceReissued = 'Invoice Reissued',
    BillReissued = 'Bill Reissued',
    AllocationCreated = 'Allocation Created',
    AllocationChanged = 'Allocation Changed',
    AllocationDeleted = 'Allocation Deleted',
    ActivityCreated = 'Activity Created',
    ActivityChanged = 'Activity Changed',
    ActivityDeleted = 'Activity Deleted',
    QuoteStatusChanged = 'Quote Status Changed',
    QuoteProCreated = 'Quote Pro Created',
    QuoteProUpdated = 'Quote Pro Updated',
    QuoteProStatusChanged = 'Quote Pro Status Changed',
    QuoteProDeleted = 'Quote Pro Deleted',
    FormSubmitted = 'Form Submitted',
    WorkOrderResourceEnroute = 'Work Order Resource Enroute',
    WorkOrderResourceOnsite = 'Work Order Resource On Site',
    OpportunityCreated = 'Opportunity Created',
    OpportunityUpdated = 'Opportunity Updated',
    OpportunityStatusChange = 'Opportunity Status Change',
    OpportunityDelete = 'Opportunity Deleted',
    SiteContactAddedUpdated = 'Site Contact Added or Updated',

    TaskCreated = 'Task Created',
    TaskChanged = 'Task Changed',
    TaskDeleted = 'Task Deleted',
    TaskCompleted = 'Task Completed',
    TaskAssigneeChanged = 'Task Assignee Changed',

    ItemCreated = 'Item Created',
    ItemChanged = 'Item Changed',
    ItemDeleted = 'Item Deleted',

    LeadCreated = 'Lead Created',
    LeadUpdated = 'Lead Updated',
    LeadStatusChange = 'Lead Status Change',
    LeadQualified = 'Lead Qualified',
    LeadLost = 'Lead Lost',
    LeadDeleted = 'Lead Deleted'
}

export interface InvoiceWebHookData {
    invoice: Invoice | Bill;
    job?: Job;
    workOrder?: WorkOrder;
}
